
import './PlantSearchResult.css';


import { useEffect, useState, useRef } from "react";
import { useSearchParams , useParams, useNavigate} from "react-router-dom";

import { searchPlants } from '../../services/plants/publicPlantsService'; 
import { useLoading } from '../../components/LoadingProvider';
// تعداد آیتم در هر صفحه رو می‌تونی از اینجا تنظیم کنی
const PAGE_SIZE = 6;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const generateMockPlants = () => {
    const names = [
        "پتوس طلایی", "زامیفولیا", "نخل شامادورا", "فیکوس الاستیکا", "آگلونما", "کالاتیا", "سانسوریا", "درختچه بونسای", "لیندا", "برگ انجیری",
        "شفلرا", "پیله آ", "پپرومیا", "آلوئه ورا", "کروتون", "کاج مطبق", "دیفن‌باخیا", "یاسمن آفریقایی", "فیتونیا", "کاکتوس"
    ];
    return names.map((name, index) => ({
        id: 200 + index,
        name,
        image: `https://picsum.photos/400/250?random=${index}`,
        group: {
            id: index % 3,
            name: ["گیاهان آپارتمانی", "گیاهان گل‌دار", "گیاهان مقاوم"][index % 3],
            image: `https://picsum.photos/400/250?random=${index + 1}`
        },
        hasReminder: index % 2 === 0
    }));
};

const allMockPlants = generateMockPlants();

const SearchResultsPage = () => {
    const [results, setResults] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    //   const [searchParams] = useSearchParams();
    //   const searchTerm = searchParams.get("searchTerm")?.toLowerCase() || "";
    const navigate = useNavigate();

    const {showLoading , hideLoading,  toast } = useLoading();
    
    const { query } = useParams();
    const searchTerm = query?.toLowerCase() || "";

    const page = useRef(0);
    const observer = useRef();
    const lastCardRef = useRef();


    const doSearch = ()=>{

        if(searchTerm.length < 3)
        {
            toast.error('حداقل ۳ کاراکتر وارد کنید');
            return;
        }

        setLoading(true);

        searchPlants(searchTerm)
        .then(data=>{
            console.log(data);

            setResults(data)

        })
        .catch(err=>{
            console.log(err);

        })
        .finally(()=>{

            setLoading(false);

        });
        

    };



    const loadMoreResults = () => {
        if (loading || !hasMore) return;

        setLoading(true);
        setTimeout(() => {
            const filtered = allMockPlants.filter(p =>
                p.name.toLowerCase().includes(searchTerm)
            );

            const start = page.current * PAGE_SIZE;
            const end = start + PAGE_SIZE;
            const nextResults = filtered.slice(start, end);

            setResults(prev => [...prev, ...nextResults]);
            page.current += 1;

            if (end >= filtered.length) setHasMore(false);
            setLoading(false);
        }, 500);

        doSearch();
    };

    // useEffect(() => {
    //     // Reset when search term changes
    //     setResults([]);
    //     page.current = 0;
    //     setHasMore(true);
    // }, [searchTerm]);

    useEffect(() => {
        // loadMoreResults();
        doSearch();
    }, [searchTerm]);

    // useEffect(() => {
    //     if (observer.current) observer.current.disconnect();

    //     observer.current = new IntersectionObserver(([entry]) => {
    //         if (entry.isIntersecting) {
    //             loadMoreResults();
    //         }
    //     });

    //     if (lastCardRef.current) {
    //         observer.current.observe(lastCardRef.current);
    //     }
    // }, [results]);

    return (
        <div className="container mt-4">
            <h2 className="mb-4">
                نتایج جستجو برای: <strong>{searchTerm}</strong>
            </h2>

            {results.length === 0 && !loading && (
                <div className="alert alert-warning">نتیجه‌ای یافت نشد</div>
            )}

            <div className="row">
                {results.map((plant, index) => {
                    const isLast = index === results.length - 1;
                    return (
                        <div
                            className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                            key={plant.id}
                            ref={isLast ? lastCardRef : null}
                        >
                            <div className="card h-100 shadow-sm">
                                <img
                                    src={BASE_URL+plant.images[0].url}
                                    className="card-img-top"
                                    alt={plant.name}
                                    style={{ objectFit: "cover", height: "180px" }}
                                />
                                <div className="card-body">
                                    <h5 className="card-title">{plant.name}</h5>
                                    <div className="mb-2 d-flex align-items-center gap-1">
                                        <img
                                            src={BASE_URL+plant.group.image}
                                            alt={plant.group.name}
                                            width="32"
                                            height="32"
                                            className="rounded"
                                        />  

                                        <small className="text-muted">{plant.group.name}</small>
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <button className="btn btn-sm btn-outline-primary"
                                        onClick={() => {
                                                 navigate(`/plants/details/${ plant._id }`);
                                        }}>
                                            مشاهده جزئیات
                                        </button>
                                        <button className="btn btn-sm btn-outline-secondary"
                                        onClick={() => {
                                            navigate(`/reminders/add/${ plant._id }`);
                                            }}>
                                            {plant.hasReminder ? "تنظیمات یادآور" : "ایجاد یادآور"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {loading && (
                <div className="text-center py-3">
                    <div className="spinner-border" role="status" />
                </div>
            )}
        </div>
    );
};

export default SearchResultsPage;
